export default {
    home_page_title: "Account-Daten",
    security_page_title: "Sicherheitszentrum",
    security_setting_page_title: "Sicherheitszentrum",
    security_phone_label: "Handy",
    security_email_label: "E-Mail",
    security_question_label: "Passwortsicherzeitsfrage",
    security_unset_text: "Nicht eingestellt",
    security_setted_text: "Schon eingestellt",
    security_question_options: [
        "Wie ist der Name Eurer Mutter?",
        "Wann hat Euer/e Partner/in Geburtstag?",
        "Wie ist der Name Eures Vaters?",
        "Wie ist Eure Matrikelnummer (oder Angestelltennummer)?",
        "Wie ist der Name Eures Kindheitsfreundes?",
        "Wie ist der Name der Person, die am meisten Einfluss auf Euch ausgeübt hat?"
    ],
    password_lost_page_title: "Passwort vergessen",
    password_reset_page_title: "Passwort zurücksetzen",
    password_lost_account_placeholder:
        "Geben Sie den Account ein, dessen Passwort Sie vergessen haben",
    empty_lost_account_tips: "Nutzername muss eingetragen werden",
    iscorrect_lost_account_tips: "Nutzer existiert nicht",
    password_reset_new_placeholder: "Neues Passwort",
    password_reset_confirm_placeholder: "Neues Passwort bestätigen",
    password_verify_page_title: "Identitätsüberprüfung",
    phone_verify_page_title: "Identitätsüberprüfung",
    email_verify_page_title: "Identitätsüberprüfung",
    question_verify_page_title: "Identitätsüberprüfung",
    phone_reset_page_title: "Handy",
    email_reset_page_title: "E-Mail",
    question_reset_page_title: "Passwortsicherzeitsfrage",
    phone_binding_text: "Verbundene Handynummer:",
    email_binding_text: "Verbundenes Postfach:",
    verification_code_text: "Verifizierungscode",
    resend_text: "Erneut versenden",
    empty_phone_number_tips: "Bitte die Handynummer eingeben",
    iscorrect_phone_number_tips:
        "Bitte eine Handynummer im richtigen Format eingeben",
    empty_verification_code_tips: "Bitte den Verifizierungscode eingeben",
    iscorrect_verification_code_tips: "Falscher Verifizierungscode",
    password_placeholder: "Passwort",
    empty_password_tips: "Passwort",
    iscorrect_password_tips: "Falsches Passwort",
    mismatched_rule_password_tips:
        "Passwörter dürfen nicht &, # und keine Leerstelle enthalten",
    different_confirm_password_tips: "Passwort stimmt nicht überein",
    empty_email_tips: "Geben Sie bitte die E-Mail-Adresse ein",
    iscorrect_email_tips: "Falsches Postfach",
    answer_placeholder: "Antwort",
    empty_question_tips: "Sicherheitsfrage",
    empty_answer_tips: "Antwort,",
    iscorrect_answer_tips: "Falsche Antwort",
    next_step_text: "Weiter",
    submit_text: "Einreichen",
    submit_success_tips: "Einstellung erfolgreich",
    submit_error_tips:
        "Der Vorgang ist fehlgeschlagen, bitte versuchen Sie es erneut",
    get_data_fail_tips:
        "Internetverbindung problematisch, bitte später versuchen.",
    use_other_verification_type_text: "Weitere Möglichkeiten zur Verifizierung",
    custom_support_notice:
        "Für diesen Account wurde noch keine Sicherheitsfrage eingestellt. Sie können über den PC den untenstehenden Link öffnen, um eine Beschwerde einzulegen" +
        process.env.VUE_APP_ORIGIN_PROFILE
};
